import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

const MessageWrapper = styled.div`
  text-align: left;
`;

const Wrapper = styled.div`
  padding-top: 5%;
`;

const UpdatedBookingPage = (props) => {
  return (
    <Wrapper>
      <MessageWrapper>
        {props.messages.change_message || 'Your booking has been successfully rescheduled'}
      </MessageWrapper>
    </Wrapper>
  );
}

export default connect(
  ({ settings }) => ({
    messages: settings.messages,
  })
)(UpdatedBookingPage);